import Alpine from "alpinejs";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const imageScaleAnimation = () => {
  Alpine.data("imageScaleAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const root = this.$root as HTMLElement;
      const image = this.$refs.image as HTMLElement | null;
      if (!image) return;

      gsap.set(image, {
        scale: 1.1,
        transformOrigin: "50% 50%",
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: "top 80%",
          once: true,
        },
      });

      tl.to(image, {
        scale: 1,
        duration: 1.2,
        ease: "power2.out",
      });

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.scrollTrigger?.kill();
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
